export const MarketResearchDescription = () => {
  return (
    <div
      style={{
        background: "#00061A",
        color: "#fff",
        marginTop: "0px",
        padding: "0 50px",
      }}
    >
      <p
        style={{
          textAlign: "justify",
          margin: "0",
          fontSize: "20px",
        }}
      >
        <br />
        <br />
      </p>
    </div>
  );
};
